import axios from "axios";

const SET_ADDITIONAL_COST = "SET_ADDITIONAL_COST";
const SET_ADDITIONAL_COST_NOTE = "SET_ADDITIONAL_COST_NOTE";
const SET_DOWN_PAYMENT = "SET_DOWN_PAYMENT";
const SET_TAX_COUNTY = "SET_TAX_COUNTY";
const SET_TAX_STATE = "SET_TAX_STATE";
const SET_TAX_ZIP = "SET_TAX_ZIP";
const SET_TERM = "SET_TERM";

const UPDATE_TERM_STARTED = "UPDATE_TERM_STARTED";
const UPDATE_TERM_SUCCESS = "UPDATE_TERM_SUCCESS";
const UPDATE_TERM_FAILURE = "UPDATE_TERM_FAILURE";

const RESET_TERM_STARTED = "RESET_TERM_STARTED";
const RESET_TERM_FAILURE = "RESET_TERM_FAILURE";

const UPDATE_CALCULATOR_SUCCESS = "UPDATE_CALCULATOR_SUCCESS";
const UPDATE_CALCULATOR_FAILURE = "UPDATE_CALCULATOR_FAILURE";

const UPDATE_DOWN_PAYMENT_OVERRIDE_AMOUNT =
  "UPDATE_DOWN_PAYMENT_OVERRIDE_AMOUNT";

export function resetTerm(contractId, calculatorData) {
  return (dispatch) => {
    dispatch(resetTermStarted());

    axios
      .put(`/contracts/${contractId}/reset-term/`)
      .then(() => dispatch(updateCalculatorData(contractId, calculatorData)))
      .catch((err) => dispatch(resetTermFailure(err.response.data.ui_message)));
  };
}

const resetTermStarted = () => ({ type: RESET_TERM_STARTED });
const resetTermFailure = (error) => ({
  type: RESET_TERM_FAILURE,
  payload: error,
});

export function updateDownPaymentOverride(contractId) {
  return (dispatch) => {
    axios.get(`/contracts/${contractId}/dp-price-override/`).then(({ data }) =>
      dispatch({
        type: UPDATE_DOWN_PAYMENT_OVERRIDE_AMOUNT,
        payload: data.amount,
      })
    );
  };
}

export function updateCalculatorData(contractId, calculatorData) {
  if (calculatorData.additional_cost == "") {
    calculatorData.additional_cost = 0.0;
  }

  if (calculatorData.additional_purchase_reserve == "") {
    calculatorData.additional_purchase_reserve == 0.0;
  }

  return (dispatch) => {
    axios
      .put(`/contracts/${contractId}/calculator-info/`, { ...calculatorData })
      .then(() => {
        if (calculatorData.tax_state) {
          calculatorData.taxState = calculatorData.tax_state;
          delete calculatorData.tax_state;
          dispatch(updateCalculatorDataSuccess(calculatorData));
        }

        if (calculatorData.additional_cost_note) {
          calculatorData.additionalCostNote =
            calculatorData.additional_cost_note;
          delete calculatorData.additional_cost_note;
          dispatch(updateCalculatorDataSuccess(calculatorData));
        }

        dispatch(updateCalculatorDataSuccess(calculatorData));
      })
      .catch((err) => dispatch(updateCalculatorDataFailure(err)));
  };
}

const updateCalculatorDataSuccess = (calculatorData) => {
  return { type: UPDATE_CALCULATOR_SUCCESS, payload: { ...calculatorData } };
};
const updateCalculatorDataFailure = (err) => ({
  type: UPDATE_CALCULATOR_FAILURE,
  payload: err.response.data.ui_message,
});

function updateTerm(term, contractId) {
  return (dispatch) => {
    dispatch(updateTermStarted());

    axios
      .put(`/contracts/${contractId}/set-term/`, term)
      .then(() => dispatch(setTerm(term)))
      .catch((err) =>
        dispatch(updateTermFailure(err.response.data.ui_message))
      );
  };
}

const updateTermStarted = () => ({ type: UPDATE_TERM_STARTED });
const updateTermSuccess = () => ({ type: UPDATE_TERM_SUCCESS });
const updateTermFailure = (error) => ({
  type: UPDATE_TERM_FAILURE,
  payload: error,
});

export function setAdditionalCost(value) {
  return { type: SET_ADDITIONAL_COST, payload: value };
}

export function setAdditionalCostNote(value, contractId = null) {
  return { type: SET_ADDITIONAL_COST_NOTE, payload: value };
}

export function setDownPayment(value) {
  return { type: SET_DOWN_PAYMENT, payload: value };
}

export function setTaxCounty(value) {
  return { type: SET_TAX_COUNTY, payload: value };
}

export function setTaxState(value, contractId = null) {
  if (contractId) {
    return resetTerm(contractId, { tax_state: value });
  }

  return { type: SET_TAX_STATE, payload: value };
}

export function setTaxZip(value) {
  return { type: SET_TAX_ZIP, payload: value };
}

export function setTerm(term, contractId = null) {
  if (contractId) {
    return updateTerm(term, contractId);
  }

  return { type: SET_TERM, payload: term };
}

function termReducer(state, action) {
  switch (action.type) {
    case RESET_TERM_STARTED:
      return {
        ...state,
        // loading: true,
      };
    case RESET_TERM_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case SET_ADDITIONAL_COST:
      return {
        ...state,
        term: {
          ...state.term,
          additionalCost: action.payload,
          selected: null,
        },
      };
    case SET_ADDITIONAL_COST_NOTE:
      return {
        ...state,
        term: {
          ...state.term,
          additionalCostNote: action.payload,
        },
      };
    case SET_DOWN_PAYMENT:
      return {
        ...state,
        term: {
          ...state.term,
          downPayment: action.payload,
          selected: null,
        },
      };
    case SET_TAX_COUNTY:
      return {
        ...state,
        term: {
          ...state.term,
          taxCounty: action.payload,
          selected: null,
        },
      };
    case SET_TAX_STATE:
      return {
        ...state,
        coRenter: !state.coRenter
          ? null
          : {
              ...state.coRenter,
              state: action.payload,
            },
        renter: {
          ...state.renter,
          state: action.payload,
        },
        term: {
          ...state.term,
          selected: null,
          taxState: action.payload,
        },
      };
    case SET_TAX_ZIP:
      return {
        ...state,
        term: {
          ...state.term,
          selected: null,
          taxZip: action.payload,
        },
      };
    case SET_TERM:
      return {
        ...state,
        loading: false,
        term: {
          ...state.term,
          selected: action.payload,
        },
      };
    case UPDATE_CALCULATOR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_CALCULATOR_SUCCESS:
      if (action.payload.taxState) {
        return {
          ...state,
          loading: false,
          coRenter: !state.coRenter
            ? null
            : {
                ...state.coRenter,
                state: action.payload.taxState,
              },
          renter: {
            ...state.renter,
            state: action.payload.taxState,
          },
          term: {
            ...state.term,
            ...action.payload,
          },
        };
      }
      return {
        ...state,
        loading: false,
        term: {
          ...state.term,
          ...action.payload,
        },
      };
    case UPDATE_DOWN_PAYMENT_OVERRIDE_AMOUNT:
      return {
        ...state,
        downPaymentOverrideAmount: action.payload,
      };
    case UPDATE_TERM_STARTED:
      return {
        ...state,
        // loading: true,
      };
    case UPDATE_TERM_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }

  return state;
}

export default termReducer;
